var map = {
	"./pr-1.png": "8f05",
	"./pr-10.png": "14c3",
	"./pr-11.png": "a26f",
	"./pr-12.png": "1874",
	"./pr-13.png": "53ee",
	"./pr-14.png": "ba05",
	"./pr-15.png": "01c4",
	"./pr-2.png": "7f7e",
	"./pr-3.png": "a509",
	"./pr-4.png": "024a",
	"./pr-5.png": "4536",
	"./pr-6.png": "f6e6",
	"./pr-7.png": "1aeb",
	"./pr-8.png": "f2c0",
	"./pr-9.png": "2a10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7930";